import React, { PureComponent, Fragment } from 'react'
import { FullHeightGrid, Row, SpacedCol, Progress, styled, updateContextState, context } from '@tools/wr-catalog-base'
import { parseUserFromToken } from '@utils/token'

const NavBackground = styled.div`
  background-color: #333333;
  height: 10rem;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  transform: translateY(-60%);
`

const SpacedRow = styled(Row)`
  padding-top: 4rem;
`

class RedirectView extends PureComponent {
  componentDidMount() {
    const token = this.props.match.params.token
    const user = parseUserFromToken(token)
    if (user) {
      updateContextState((state) => {
        state.isLoggedIn = true
        state.user = user
      })
      context.persistentStorage.set('ptcToken', token)
      context.history.replace(context.getRoutePath('index'))
      if (user && user.email) {
        const uid = user.email.replace(/@.+/, '')
        const exp = new Date()
        exp.setFullYear(exp.getFullYear() + 1)
        document.cookie = `uid=${uid}; expires=${exp.toUTCString()}; path=/`
        window.s_props = {
          prop1: user.email.substring(0, user.email.lastIndexOf('@')),
        }
      }
    }
  }

  render() {
    return (
      <Fragment>
        <NavBackground />
        <FullHeightGrid>
          <SpacedRow center="xs">
            <SpacedCol xs={12}>
              <Progress />
            </SpacedCol>
            <SpacedCol xs={12}>
              <p>Logging you in...</p>
            </SpacedCol>
          </SpacedRow>
        </FullHeightGrid>
      </Fragment>
    )
  }
}

export default RedirectView
